import request from "root/js/request";

export const getParsersCollectionsProducts = async ({ limit, offset, ...rest }) => {
  const response = await request({
    url: `/parsers/collections/products/`,
    method: "get",
    params: {
      limit,
      offset,
      ...rest,
    },
  });
  return response.data;
};
